export const CUSTOMER_LIST = 'CUSTOMER_LIST';
export const CUSTOMER_GET = 'CUSTOMER_GET';
export const CUSTOMER_CLEAR = 'CUSTOMER_CLEAR';
export const CUSTOMER_GET_ADDITIONAL_DATA = 'CUSTOMER_GET_ADDITIONAL_DATA';